// Mock data for La Grande Brune Restaurant

export const restaurantInfo = {
  name: "La Grande Brune",
  address: "7 Promenade des Anglais, Nice",
  phone: "04 83 93 48 37",
  instagram: "lagrandebrune.restaurant",
  reservationLink: "https://bookings.zenchef.com/results?rid=376097&pid=1001&utm_source=ig&utm_medium=social&utm_content=link_in_bio",
  email: "lagrandebrunerestaurant@gmail.com",
  menuPDF: "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/7jyvae5n_MENU%20FRANCAIS.pdf%20%2814.8%20x%2021%20cm%29%20copie.pdf"
};

export const images = {
  hero: [
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/vjhh62m3_PHOTO-2025-12-15-19-57-37%203.jpg",
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/wo0m7isf__.jpeg"
  ],
  nightlife: [
    "https://images.unsplash.com/photo-1582819509237-d5b75f20ff7a?q=85&w=1920",
    "https://images.unsplash.com/photo-1656423376380-96a71e3cf27f?q=85&w=1920"
  ],
  lunch: [
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/g6gvzlqu_LGB-60.JPG",
    "https://images.unsplash.com/photo-1611520175743-30ff00129621?q=85&w=1920"
  ],
  diner: [
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/midhp2vw_fullsizeoutput_1f9b.jpeg",
    "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=85&w=1920"
  ],
  bar: [
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/p7gsoe7d_Martini%20-%20Gin%20Cocktail.jpeg",
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/utx72rw5__%20%281%29.jpeg"
  ],
  cuisine: [
    "https://images.unsplash.com/photo-1746785011440-aff1c8e0e559?q=85&w=1920",
    "https://images.unsplash.com/photo-1746785011420-504d56709419?q=85&w=1920",
    "https://images.unsplash.com/photo-1663530761401-15eefb544889?q=85&w=1920"
  ],
  vip: [
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/1hn91bj5_IMG_0147%202.jpg",
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/c7or6f2o_LGB-44.jpg"
  ],
  gallery: [
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/yxbmkstk_LGB-31.jpg",
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/172ygbsp_LGB-13.jpg",
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/wvutkcny_LGB-62.jpg",
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/uo79z1kc_LGB-57.jpg",
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/hlj1gr8t_cb8ef021-b4d5-49d6-bcf5-fa0d35c266fc.JPG",
    "https://customer-assets.emergentagent.com/job_elegant-dining-44/artifacts/g6gvzlqu_LGB-60.JPG"
  ]
};

export const menuItems = {
  starters: [
    { name: "Carpaccio de Saint-Jacques", description: "Agrumes et caviar", price: "28€" },
    { name: "Foie Gras de Canard", description: "Chutney de figues", price: "24€" },
    { name: "Tartare de Thon Rouge", description: "Avocat et sésame", price: "26€" }
  ],
  mains: [
    { name: "Bar de Ligne", description: "Légumes de saison rôtis", price: "42€" },
    { name: "Côte de Bœuf", description: "Sauce béarnaise et frites maison", price: "58€" },
    { name: "Risotto aux Truffes", description: "Copeaux de parmesan", price: "36€" }
  ],
  desserts: [
    { name: "Soufflé au Chocolat", description: "Glace vanille bourbon", price: "16€" },
    { name: "Tarte Tatin", description: "Crème fraîche épaisse", price: "14€" },
    { name: "Crème Brûlée", description: "Parfum lavande", price: "12€" }
  ]
};

export const cocktails = [
  { name: "La Grande Signature", description: "Gin, elderflower, champagne", price: "18€" },
  { name: "Riviera Sunset", description: "Vodka, passion fruit, prosecco", price: "16€" },
  { name: "Negroni Blanc", description: "Gin, Lillet, Suze", price: "15€" },
  { name: "French 75", description: "Cognac, citron, champagne", price: "17€" }
];

export const instagramPosts = [
  {
    id: 1,
    image: images.cuisine[0],
    likes: 342,
    caption: "Nouvelle création du chef 👨‍🍳✨"
  },
  {
    id: 2,
    image: images.nightlife[0],
    likes: 528,
    caption: "Soirée exceptionnelle avec @djname 🎵"
  },
  {
    id: 3,
    image: images.vip[0],
    likes: 421,
    caption: "Espace privé disponible pour vos événements 🥂"
  },
  {
    id: 4,
    image: images.lunch[1],
    likes: 289,
    caption: "Déjeuner d'affaires au soleil ☀️"
  }
];

export const events = [
  {
    id: 1,
    date: "2025-01-15",
    title: "Live Jazz Night",
    description: "Soirée jazz avec quartet international",
    time: "21h00"
  },
  {
    id: 2,
    date: "2025-01-20",
    title: "DJ Set Électro",
    description: "Ambiance électro avec DJ résident",
    time: "23h00"
  },
  {
    id: 3,
    date: "2025-01-27",
    title: "Showcase Acoustique",
    description: "Performance acoustique intimiste",
    time: "20h00"
  }
];
